/**
 *
 * CheckBoxCard
 *
 */
import React, { memo } from 'react';
import { FormikProps, FieldInputProps } from 'formik';
import { FormControlLabel, Checkbox, FormHelperText, Box } from '@mui/material';
import clsx from 'clsx';
import colors from 'app/assets/styles/colors';
import { makeThemeStyle } from 'styles/makeThemeStyle';

interface Props {
  form: FormikProps<any>;
  field: FieldInputProps<any>;
  label: string;
  helperText: string;
  size?: 'compact' | 'normal';
}

const useStyles = makeThemeStyle(theme => ({
  formControlRoot: {
    width: '100%',
    color: colors.silverGray,
    marginLeft: 0,
    padding: theme.spacing(0.5),
    paddingRight: theme.spacing(2),
    borderRadius: 8,
    border: `1px solid ${colors.silverGray}`,
  },
  checked: { color: theme.palette.asseticPrimary.main },
  hover: {
    '&:hover': { color: theme.palette.asseticPrimary.main },
  },
  checkbox: {
    marginTop: 0,
    alignSelf: 'flex-start',
  },
}));

export const FormCheckBoxCard = memo((props: Props) => {
  const isCompact = props.size !== 'normal';
  const classes = useStyles();
  return (
    <>
      <FormControlLabel
        className={clsx(classes.formControlRoot, classes.hover, {
          [classes.checked]: props.field.checked,
        })}
        label={
          <Box height={isCompact ? 60 : 80} mt={1} marginBottom={1.5}>
            <Box>{props.label}</Box>
            <FormHelperText>{props.helperText}</FormHelperText>
          </Box>
        }
        control={
          <Checkbox
            className={classes.checkbox}
            color="primary"
            {...props.field}
          />
        }
      />
    </>
  );
});
